import React from 'react';
import { Card, Container, Row, Col, Badge } from 'react-bootstrap';
import '../../shared-styling.css';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import BackButton from '../../components/BackButton';
import { Link } from 'react-router-dom';

export default function DataAnalytics() {
    const navigate = useNavigate();



    return (
        <div className="page-styling">
            <button
                className="arrow-btn"
                onClick={() => navigate(-1)}
                style={{
                    margin: '1.5rem',
                    top: '1rem',
                    left: '1rem',
                    zIndex: 999999,
                }}
            >
                ‹
            </button>


            <Container className="py-5">
                <h1 className="mb-4 text-center">Data Science Final Project</h1>

                { /* SLIDES */}
                <div style={{
                    borderRadius: '24px',
                    overflow: 'hidden',
                    width: '68.6%',        /* reduce width */
                    margin: '4rem auto 0'  /* centers it + adds top spacing */
                }}>
                    <iframe
                        src="https://www.canva.com/design/DAHRQ8N4mWw/71PrYn23MKv-QyLIHhSiZw/view"
                        width="100%"
                        height="500"
                        allowFullScreen
                        style={{ display: 'block' }}
                    />
                </div>
            </Container>
        </div>
    );
}

